import { render, staticRenderFns } from "./TournamentOverview.vue?vue&type=template&id=a8d679d6&scoped=true"
import script from "./TournamentOverview.vue?vue&type=script&lang=js"
export * from "./TournamentOverview.vue?vue&type=script&lang=js"
import style0 from "./TournamentOverview.vue?vue&type=style&index=0&id=a8d679d6&prod&lang=scss&scoped=true"
import style1 from "./TournamentOverview.vue?vue&type=style&index=1&id=a8d679d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d679d6",
  null
  
)

export default component.exports